<template>
    <div class="point">
        <div class="header">
            
        </div>
        <List v-model="loading" :finished="finished" finished-text="没有更多了" @load="getlist">
            <div class="item" v-for="item in list" :key="item.id">
                <div class="top">
                    <div class="rank_icon">
                        <template v-if="item.rank <= 3">
                            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230908/1694150725/429636.png" :alt="item.rank" v-if="item.rank == 1" />
                            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230908/1694150725/335383.png" :alt="item.rank" v-if="item.rank == 2" />
                            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230908/1694150725/690730.png" :alt="item.rank" v-if="item.rank == 3" />
                        </template>

                        <span v-else>{{ item.rank }}</span>
                    </div>
                    <div class="title">
                        <div>{{item.name}}</div>
                        <div>
                            所属类型：{{item.type | statusFiler}}
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <!-- <div>
                        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/123250.png" alt="">
                    </div> -->
                    <div>
                        <span>{{item.point}} 分</span>
                    </div>
                </div>
            </div>
        </List>
    </div>
</template>

<script>
import { Search,List } from 'vant';
import localforage from 'localforage'
export default {
    components: {
        vanSearch: Search,List
    },
    data() {
        return {
            keywords: '',
            order: 1,
            page: 1,
            finished: false,
            loading: false,
            list: []
        }
    },
    filters: {
        statusFiler(val) {
            switch(val*1) {
                case 1:
                    return '单项联盟'
                case 2:
                    return '区域联盟'
            }
        }
    },
    mounted() {

    },
    methods: {
        go(item) {
            this.$router.push({name:'groupdetail',params: {aid:item.id}})
        },
        onSearch(val) {
            this.keywords = val
            this.finished = false
            this.list = []
        },
        onClick(name, title) {
            this.type = name
            this.finished = false
            this.list = []
        },
        async getlist() {
            const userInfo = await localforage.getItem('userInfo')
            // console.log(userInfo)
            let query = {
                order: this.order,
                keywords: this.keywords,
                page: this.page,
                openid: userInfo.openid
            }
            this.$api.system.grouplist(query).then((res) => {
                if (res.code * 1 === 200) {
                    this.loading = false
                    let { list, page, pages } = res.data
                    this.list = this.list.concat(list)

                    let t = null

                    this.list.forEach((item, index) => {
                        if (t == null) {
                            t = item;
                            t.rank = index + 1;
                        } else {
                            var n = item;
                            if (n.point * 1 == t.point * 1) {
                                n.rank = t.rank;
                            } else {
                                n.rank = index + 1;
                            }
                            t = n;
                        }
                    })
                    if (page >= pages) this.finished = true
                    else this.page++
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.point{
    // background: #E6F2FE;
    overflow-y: auto;
    width: 100%;
    height: auto;
    .header{
        background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20230908/1694138321/431541.png) no-repeat;
        width: 100%;
        height: 3.23rem;
        background-size: 100% 100%;
    }
    .van-list{
        box-sizing: border-box;
        padding: .3rem;
        .item{
            box-sizing: border-box;
            padding: .3rem;
            // width: 6.93rem;
            // height: 2.48rem;
            margin-bottom: .28rem;
            background: #FFFFFF;
            box-shadow: 0px 0px .18rem 0px rgba(0,0,0,0.06);
            border-radius: .12rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .top{
                font-size: .28rem;
                color: rgba(0,0,0,0.45);
                display: flex;
                // box-sizing: border-box;
                // padding: .37rem .45rem .32rem;
                align-items: center;
                .rank_icon{
                    align-self: flex-start;
                    // width: .44rem;
                    // height: .61rem;
                    img{
                        width: .44rem;
                        height: .61rem;
                        margin-top: .1rem;
                    }
                }
                .title{
                    // width: 4.8rem;
                    margin-left: .3rem;
                    >div:first-child{
                        font-size: .32rem;
                        color: rgba(0,0,0,0.85);
                        font-weight: 500;
                        padding-bottom: .1rem;
                    }
                    >div:nth-child(2){
                        font-size: .24rem;
                        color: #95999F;
                        display: flex;
                        align-items: center;
                        >div:first-child{
                            width: .3rem;
                            height: .3rem;
                            img{
                                width: .3rem;
                                height: .3rem;
                            }
                        }
                        
                    }
                }
            }
            .bottom{
                display: flex;
                align-items: center;
                // box-sizing: border-box;
                // padding: 0 .45rem;
                font-size: .24rem;
                color: rgba(0,0,0,0.45);
                img{
                    width: .26rem;
                    height: .26rem;
                    margin-right: .1rem;
                }
            }
        }
    }
}
</style>